/**
 * Türkiye saati (UTC+3) odaklı tarih/saat yardımcıları.
 * Tüm formlarda tarih-saat ayarı bu fonksiyonlar üzerinden yapılmalıdır.
 */

/**
 * Bugünün tarih stringini YYYY-MM-DD formatında yerel (Türkiye) saatine göre döndürür.
 * new Date().toISOString().split('T')[0] UTC'ye göre olduğundan gece yarısı civarı yanlış gün verir.
 */
export const getLocalDateString = (date = new Date()) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

/**
 * Şu anki tam ISO string (UTC) - backend'e kayıt için.
 * Browser bu ISO'yu yerel saatte gösterir.
 */
export const getCurrentIsoDateTime = () => new Date().toISOString();

/**
 * YYYY-MM-DD formatında bir tarih string'ini, YEREL SAAT ile birleştirip ISO döndürür.
 * Kullanıcı takvimden tarih seçtiğinde, seçtiği günün o anki saatinde kaydedilmesini sağlar.
 * Aksi halde new Date("2026-04-21").toISOString() UTC gece yarısını verir ve Türkiye'de 03:00 görünür.
 *
 * @param {string} dateStr - "YYYY-MM-DD" formatında tarih
 * @returns {string} ISO UTC string
 */
export const combineDateWithCurrentTime = (dateStr) => {
  if (!dateStr) return getCurrentIsoDateTime();
  const [y, m, d] = dateStr.split('-').map(Number);
  const now = new Date();
  const combined = new Date(
    y,
    m - 1,
    d,
    now.getHours(),
    now.getMinutes(),
    now.getSeconds(),
    now.getMilliseconds()
  );
  return combined.toISOString();
};

/**
 * Dünün tarih stringini YYYY-MM-DD formatında yerel saatine göre döndürür.
 */
export const getYesterdayLocalDateString = () => {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return getLocalDateString(d);
};

/**
 * Şu anki saati dün günde oluşturup ISO döndürür (dün aynı saatte).
 */
export const getYesterdayIsoDateTime = () => {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return d.toISOString();
};
